import Tesla1 from '../../../media/Residentials/Tesla/Tesla.webp'
import Tesla2 from '../../../media/Residentials/Tesla/Tesla.webp'


const Teslaimages =[
Tesla1,Tesla2
]

export default Teslaimages;